import { TextColorType } from "@/lib/main";
import { CSSProperties, HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  className?: HTMLAttributes<HTMLParagraphElement>["className"];
  color?: TextColorType;
  fontWeight?: 400 | 500;
  id?: HTMLAttributes<HTMLParagraphElement>["id"];
  lineHeight?: string;
  onClick?: HTMLAttributes<HTMLParagraphElement>["onClick"];
  ref?: React.Ref<HTMLParagraphElement>;
  size?: "tabbar" | "caption";
  style?: CSSProperties;
  textAlign?: CSSProperties["textAlign"];
}>;

export default function Caption({
  children,
  className,
  color,
  fontWeight,
  id,
  size,
  style,
  textAlign,
  lineHeight,
  onClick,
  ref,
}: Props) {
  const styles: CSSProperties = {
    color: `var(--color-text-${color || "primary"})`,
    fontSize:
      size === "tabbar"
        ? "var(--font-size-tabbar-item)"
        : "var(--font-size-caption)",
    fontWeight: fontWeight || 400,
    textAlign: textAlign || "start",
    lineHeight: lineHeight || undefined,
    ...style,
  };

  return (
    <p className={className} id={id} onClick={onClick} ref={ref} style={styles}>
      {children}
    </p>
  );
}
